import React, { useState, useEffect } from "react";
import {
  Table,
  Spinner,
  
} from "reactstrap";

import { deviceSessionAPI, deviceSessionCountAPI } from "../services/Device";
import { useHistory, useLocation } from "react-router-dom";
import TableHeader from "components/TableHeader";

const deviceSessionCache = {};
// removeDeviceSession
const deviceDetils = ({ match }) => {
  const [deviceSession, setDeviceSession] = useState([]);
  const [loading, setLoading] = useState(false);


  const history = useHistory();
  const location = useLocation();

  const lastKeyRef = React.useRef(null);
  const isFetchingMore = React.useRef(false);
  const isInternalNavigationRef = React.useRef(false);
  const lastActivePageRef = React.useRef(parseInt(match.params.page) || 1);
  const isInitialMountRef = React.useRef(true);

  const [totalCount, setTotalCount] = useState(null);

  useEffect(() => {
    let isMounted = true;
    deviceSessionCountAPI(match.params.id).then(res => {
        if (isMounted && res.success) setTotalCount(res.count);
    }).catch(err => console.error("Count fetch failed:", err));
    return () => { isMounted = false; };
  }, [match.params.id]);

  //pagination
  const currentPage = parseInt(match.params.page) || 1;
  const [recordsPerPage, setRecordsPerPage] = useState(() => {
    const saved = localStorage.getItem("device_sessions_limit");   
  const parsed = parseInt(saved);
    return [500, 1000, 2000].includes(parsed) ? parsed : 2000;
  });

  const handleRecordsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setRecordsPerPage(newLimit);
    localStorage.setItem("device_sessions_limit", newLimit);
    const indexOfFirstRecord = (currentPage - 1) * recordsPerPage;
    const newPage = Math.floor(indexOfFirstRecord / newLimit) + 1;
    isInternalNavigationRef.current = true;
    history.replace(`/device/${match.params.id}/p${newPage}`);
  };

  const [fetchingMore, setFetchingMore] = useState(false);

  const refreshlist = () => {
    setLoading(true);
    const btn = document.getElementById("refreshbtn");
    if (btn) btn.className = "fas fa-sync fa-spin";
    delete deviceSessionCache[match.params.id];
    if (currentPage !== 1) {
      goToPage(1);
    } else {
      getAllDeviceSession(false, true, 1);
    }
  };
  const goToPage = (page) => {
    isInternalNavigationRef.current = true;
    history.replace(`/device/${match.params.id}/p${page}`);
  };

  // Redirect missing page to p1 and strip limit if present in URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    let pathChanged = false;

    if (!match.params.page) {
      pathChanged = true;
    }

    if (searchParams.has("limit")) {
      searchParams.delete("limit");
      pathChanged = true;
    }

    if (pathChanged) {
      const page = match.params.page || "1";
      const searchStr = searchParams.toString();
      const newSearch = searchStr ? `?${searchStr}` : "";
      isInternalNavigationRef.current = true;
      history.replace(`/device/${match.params.id}/p${page}${newSearch}`);
    }
  }, [match.params.page, match.params.id, location.search, history]);

  // Guard against manual URL changes: if user types in browser address bar, block & revert back to last active page.
  // Also, if the page is refreshed (reloaded), redirect immediately to page 1 (p1).
  useEffect(() => {
    const parsedPage = parseInt(match.params.page) || 1;

    if (isInitialMountRef.current) {
      const isReload = 
        (window.performance && window.performance.navigation && window.performance.navigation.type === 1) ||
        (window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0]?.type === 'reload');

      if (isReload && parsedPage !== 1) {
        isInternalNavigationRef.current = true;
        history.replace(`/device/${match.params.id}/p1${location.search}`);
        lastActivePageRef.current = 1;
      } else {
        lastActivePageRef.current = parsedPage;
      }
      isInitialMountRef.current = false;
      return;
    }

    if (parsedPage !== lastActivePageRef.current) {
      if (isInternalNavigationRef.current) {
        // Allowed internal navigation: update the last active page and reset flag
        lastActivePageRef.current = parsedPage;
        isInternalNavigationRef.current = false;
      } else {
        // Blocked external/manual navigation: revert URL to last active page immediately
        history.replace(`/device/${match.params.id}/p${lastActivePageRef.current}${location.search}`);
      }
    }
  }, [match.params.page, match.params.id, location.search, history]);

  useEffect(() => {
    if (!match.params.page) return;

    const parsedPage = parseInt(match.params.page) || 1;
    // BLOCK any fetch if this is an external/manual URL change that hasn't been allowed (internal)!
    if (parsedPage !== lastActivePageRef.current && !isInternalNavigationRef.current) {
      return;
    }

    // BLOCK any fetch if we are reloading/refreshing and redirecting to page 1 (p1)
    const isReload = 
      (window.performance && window.performance.navigation && window.performance.navigation.type === 1) ||
      (window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0]?.type === 'reload');

    if (isReload && parsedPage !== 1) {
      return;
    }

    let isMounted = true;
    const targetCount = currentPage * recordsPerPage;
    const cached = deviceSessionCache[match.params.id] || [];

    if (isFetchingMore.current) return;

    if (deviceSession.length >= targetCount || (!lastKeyRef.current && deviceSession.length > 0)) {
      return;
    }

    if (cached.length >= targetCount || (!lastKeyRef.current && cached.length > 0)) {
      setDeviceSession(cached);
      getAllDeviceSession(true, isMounted, currentPage);
    } else {
      getAllDeviceSession(false, isMounted, currentPage);
    }

    return () => { isMounted = false; };
  }, [match.params.id, currentPage, recordsPerPage]);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = deviceSession.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );

  const totalPages = Math.ceil((totalCount ?? deviceSession.length) / recordsPerPage);

  const getAllDeviceSession = async (
  isBackground = false,
  isMounted = true,
  targetPage = currentPage,
) => {
  try {
    if (!isBackground) setLoading(true);
    lastKeyRef.current = null;

    let allSessions = [];
    let currentLastKey = null;
    const targetCount = targetPage * recordsPerPage;

    do {
      const response = await deviceSessionAPI(match.params.id, recordsPerPage, currentLastKey);
      if (!isMounted) return;

      if (response.success && Array.isArray(response.sessions)) {
        allSessions = [...allSessions, ...response.sessions];
        currentLastKey = response.lastKey || null;
        lastKeyRef.current = currentLastKey;

        if (!currentLastKey) {
          break;
        }
      } else {
        break;
      }
    } while (allSessions.length < targetCount && currentLastKey);

    // DynamoDB already returns records in descending order (ScanIndexForward: false)
    // Do NOT re-sort — re-sorting causes records to shift positions across page boundaries
    deviceSessionCache[match.params.id] = allSessions;
    if (isMounted) setDeviceSession(allSessions);

  } catch (error) {
    console.error("Failed to load sessions:", error);
    if (isMounted) setDeviceSession([]);
  } finally {
    if (isMounted) {
      setLoading(false);
      const btn = document.getElementById("refreshbtn");
      if (btn) btn.className = "fas fa-sync fa-stop";
    }
  }
};
  function downloadCSV(csv, filename) {
    var csvFile;
    var downloadLink;

    //define the file type to text/csv
    csvFile = new Blob([csv], { type: "text/csv" });
    downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";

    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
  function exportTableToCSV() {
    //declare a JavaScript letiable of array type
    let csv = [];
    let rows = document.querySelectorAll("table tr");

    //merge the whole data in tabular form
    for (let i = 0; i < rows.length; i++) {
      let row = [],
        cols = rows[i].querySelectorAll("td, th");
      for (let j = 0; j < cols.length; j++) row.push(cols[j].innerText);
      csv.push(row.join(","));
    }
    //call the function to download the CSV file
    let filename = "Device_Events_" + new Date().toLocaleDateString();
    downloadCSV(csv.join("\n"), filename);
  }

  const timeFormatting = (timestamp) => {
    const isLeapYear = (year) => {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    };
    const getDaysInMonth = (month, year) => {
      const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (month === 1 && isLeapYear(year)) {
        return 29;
      }
      return daysInMonth[month];
    };
    const [datePart, timePart] = timestamp.split("-");
    const [hours, minutes, seconds] = timePart.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12;
    const formattedTime = `(${hours12.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")} ${period})`;

    const [day, month, year] = datePart.split(":").map(Number);

    let dayInt = day + 1;
    let monthInt = month;
    let yearInt = year;

    if (dayInt > getDaysInMonth(monthInt, yearInt)) {
      dayInt = 1;
      monthInt += 1;

      if (monthInt >= 12) {
        monthInt = 0;
        yearInt += 1;
      }
    }

    const newDatePart = `${(monthInt + 1)
      .toString()
      .padStart(2, "0")}/${dayInt.toString().padStart(2, "0")}/${yearInt}`;

    const newTimestamp = `${newDatePart} ${formattedTime}`;

    const newTimePart = `${hours12.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")} ${period}`;
    const newDate = new Date(`${newDatePart} ${newTimePart}`);
    const currentDate = new Date();

    if (newDate > currentDate) {
      return timestamp;
    }
    return newTimestamp;
  };

  const timeFormatMinSec = (dateStr) => {
    if (
      typeof dateStr == "undefined" ||
      dateStr == undefined ||
      dateStr == "undefined" ||
      dateStr < 1520160669214
    ) {
      return " ";
    }
    let date = new Date(parseInt(dateStr));
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime =
      (" 0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2) + " " + ampm;
    let newDate = new Date(parseInt(dateStr)).toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    return newDate + " (" + strTime + ")";
  };

  const showRecords = () => {
    // Full-page loader: initial load OR navigating to a page whose records are still being fetched
    if (loading || (fetchingMore && currentRecords.length === 0)) {
      return (
        <tr>
          <td colSpan="9" style={{ textAlign: "center", padding: "60px 0" }}>
            <Spinner animation="border" style={{ width: "2.5rem", height: "2.5rem", color: "#525f7f" }} />
            <div style={{ marginTop: 12, color: "#6c757d", fontSize: 14 }}>Fetching more records...</div>
          </td>
        </tr>
      );
    }

    if (deviceSession.length > 0 && currentRecords.length > 0) {
      return (
        <>
          {currentRecords.map((item, index) => (
            <tr key={item.id || index}>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>{indexOfFirstRecord + index + 1}</td>
              <td style={{ textAlign: "left" }}>{item.macAdd || "-"}</td>
              <td style={{ textAlign: "left" }}>{item.prcId || "-"}</td>
              <td style={{ textAlign: "left" }}>{item.platform || "-"}</td>
              <td style={{ textAlign: "left" }}>{item.eventId || "-"}</td>
              <td style={{ textAlign: "left" }}>{item.description || "-"}</td>
              <td style={{ textAlign: "left" }}>{item.data || "0"}</td>
              <td style={{ textAlign: "left" }}>
                {item?.eventTime &&
                new Date(item.eventTime).getFullYear() < 2015
                  ? timeFormatMinSec(item?.updatedAt)
                  : item?.eventTime
                    ? item?.eventTime
                    : item?.minutes
                      ? timeFormatting(item?.minutes)
                      : "-"}
              </td>
              <td style={{ textAlign: "left" }}>
                {timeFormatMinSec(item.updatedAt) || "-"}
              </td>
            </tr>
          ))}
          {fetchingMore && (
            <tr>
              <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
                <Spinner size="sm" style={{ marginRight: 8 }} />
                <span style={{ fontSize: 13, color: "#6c757d" }}>
                  Fetching more records...
                </span>
              </td>
            </tr>
          )}
        </>
      );
    }

    return (
      <tr>
        <td colSpan="9" style={{ textAlign: "center", padding: "60px 0" }}>
          No Record Found!
        </td>
      </tr>
    );
  };


return (
  <div style={{ display: "flex", flexDirection: "column", background: "#fff", height: "100vh", overflow: "hidden" }}>
    
    <TableHeader
      title="Device Events"
      onBack={() => history.goBack()}
      onRefresh={refreshlist}
      onDownload={exportTableToCSV}
     totalCount={Math.max(totalCount ?? 0, deviceSession.length)}
      hasMore={false}
    />

    {/* Scrollable table body */}
    <div style={{ flex: 1, overflowY: "auto", background: "#fff" }}>
      <Table striped hover responsive bordered className="align-items-center table-flush" style={{ margin: 0 }}>
        <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
          <tr>
            <th scope="col" style={{ textAlign: "left", width: "80px" }}>S.No.</th>
            <th scope="col" style={{ textAlign: "left" }}>Remote Control Id</th>
            <th scope="col" style={{ textAlign: "left" }}>Ring Id</th>
            <th scope="col" style={{ textAlign: "left" }}>Platform</th>
            <th scope="col" style={{ textAlign: "left" }}>Event Type</th>
            <th scope="col" style={{ textAlign: "left" }}>Event Description</th>
            <th scope="col" style={{ textAlign: "left" }}>Data</th>
            <th scope="col" style={{ textAlign: "left" }}>Event Time</th>
            <th scope="col" style={{ textAlign: "left" }}>Updated Date</th>
          </tr>
        </thead>
        <tbody>{showRecords()}</tbody>
      </Table>
    </div>

    {/* Fixed pagination bar */}
    {!loading && deviceSession.length > 0 && (
      <div style={{
        borderTop: "1px solid #e9ecef",
        padding: "16px 16px",
        background: "#fff",
        flexShrink: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          <span style={{ fontSize: 13, color: "#6b7280", marginRight: 8, fontWeight: 500 }}>Records per page:</span>
          <select
            value={recordsPerPage}
            onChange={handleRecordsPerPageChange}
            style={{
              padding: "5px 10px",
              borderRadius: 6,
              border: "1px solid #dee2e6",
              background: "#fff",
              fontWeight: 500,
              fontSize: 13,
              cursor: "pointer",
              outline: "none",
              color: "#374151"
            }}
          >
            <option value={500}>500</option>
            <option value={1000}>1000</option>
            <option value={2000}>2000</option>
          </select>
        </div>
        <div style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
          <button
  disabled={currentPage === 1}
  onClick={() => goToPage(currentPage - 1)}
  style={{
    padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6",
    background: currentPage === 1 ? "#f8f9fa" : "#fff",
    cursor: currentPage === 1 ? "not-allowed" : "pointer", fontWeight: 500,
  }}
>←</button>
          <div style={{ padding: "6px 14px", borderRadius: 6, background: "#f2f0f0", color: "#0e0d0d", fontWeight: 500, fontSize: 14 }}>
          {indexOfFirstRecord < deviceSession.length ? (
            `${indexOfFirstRecord + 1}–${Math.min(indexOfLastRecord, deviceSession.length)}`
          ) : (
            `Loading...`
          )} of {Math.max(totalCount ?? 0, deviceSession.length)}
          </div>
          <button
  disabled={(currentPage === totalPages && !lastKeyRef.current) || fetchingMore}
  onClick={async () => {
    const nextPage = currentPage + 1;
    const nextPageLastRecord = nextPage * recordsPerPage;
    if (nextPageLastRecord > deviceSession.length && lastKeyRef.current) {
      // 1. Lock the ref so the page-change useEffect doesn't trigger getAllDeviceSession
      isFetchingMore.current = true;
      setFetchingMore(true);
      // 2. Navigate to next page IMMEDIATELY → renders with empty currentRecords → full loader shows
      goToPage(nextPage);
      // 3. Fetch the next batch
      try {
        const response = await deviceSessionAPI(match.params.id, recordsPerPage, lastKeyRef.current);
        if (response.success && Array.isArray(response.sessions)) {
          lastKeyRef.current = response.lastKey;
          setDeviceSession(prev => {
            const combined = [...prev, ...response.sessions];
            deviceSessionCache[match.params.id] = combined;
            return combined;
          });
        }
      } catch (e) {
        console.error("Failed to fetch next page:", e);
      } finally {
        isFetchingMore.current = false;
        setFetchingMore(false);
      }
    } else {
      goToPage(nextPage);
    }
  }}
  style={{
    padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6",
    background: (currentPage === totalPages && !lastKeyRef.current) || fetchingMore ? "#f8f9fa" : "#fff",
    cursor: (currentPage === totalPages && !lastKeyRef.current) || fetchingMore ? "not-allowed" : "pointer", fontWeight: 500,
  }}
>{fetchingMore ? "..." : "→"}</button>
        </div>
      </div>
    )}

  </div>
);
};
export default deviceDetils;
